module.exports = __webpack_public_path__ + "src/assets/sandbox_ss.png";